import React from 'react';
import type { CaseStatus } from '../../types/admin';
const tones: Record<CaseStatus, string> = {
  'Ny henvendelse': 'bg-accent-soft text-accent-deep border-[#e6cfc2]',
  'Kontaktet': 'bg-[#eef2f4] text-status-info border-[#d9e2e7]',
  'Tilbud sendt': 'bg-[#fbf3e0] text-status-warn border-[#f0e2bf]',
  'Accepteret': 'bg-[#eaf1ea] text-status-ok border-[#d3e3d5]',
  'Planlagt': 'bg-[#eceff2] text-status-info border-[#dbe1e6]',
  'I gang': 'bg-[#e9eef6] text-[#33507e] border-[#d3ddec]',
  'Færdig': 'bg-[#eaf1ea] text-status-ok border-[#d3e3d5]',
  'Faktureret': 'bg-ink text-white border-ink'
};
export function StatusBadge({
  status,
  className = ''
}: {
  status: CaseStatus;
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-medium ${tones[status]} ${className}`} data-id="element-314" data-mp="1f0br4iydbkz5">
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" aria-hidden="true" data-id="element-315" data-mp="mir3xvf438nh" />
      {status}
    </span>;
}